import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { router, usePage } from '@inertiajs/vue3';

export const notifications = {
  install() {
    const toast = useToast();
    
    router.on('finish', () => {
      const notification = usePage().props.notification;

      if (notification) {
        toast(notification.body, { type: notification.type });
      }
    });
  }
};
